export enum Status {
    Initial = 'Initial',
    Loading = 'Loading',
    Ready = 'Ready',
    Error = 'Error',
}

export const isLoading = (status: Status): boolean => {
    return status === Status.Loading;
};

export const isReady = (status: Status): boolean => {
    return status === Status.Ready;
};

export const isError = (status: Status): boolean => {
    return status === Status.Error;
};
